import React from "react";
import SuperAdminHolidays from "../superadmin/policies/HolidayPage";

const HolidaysPage = () => {
    return <SuperAdminHolidays />;
};

export default HolidaysPage;
